import i18n from '../index';

/**
 * Elapsed time from an ISO timestamp to now, for queue metrics and similar UI.
 * Uses the queues namespace for hour/minute unit layout per locale.
 */
export const formatDurationFromTimestamp = (
  timestamp: string | null | undefined,
): string => {
  const format = (hours: number, minutes: number) =>
    i18n.t('queues:metrics.durationHoursMinutes', {
      hours,
      minutes,
      defaultValue: '{{hours}}h {{minutes}}m',
    });

  if (timestamp === null || timestamp === undefined || timestamp === '') {
    return format(0, 0);
  }
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) {
    return format(0, 0);
  }
  const ms = Date.now() - date.getTime();
  if (ms <= 0) {
    return format(0, 0);
  }
  const hours = Math.floor(ms / (1000 * 60 * 60));
  const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
  return format(hours, minutes);
};
